import React, { useState, useEffect, useRef } from 'react';
import BrandLogo from "../assets/images/brandlogo.png";
import {
    MDBContainer,
    MDBNavbar,
    MDBNavbarBrand,
    MDBNavbarToggler,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBNavbarLink,
    MDBCollapse,
    MDBIcon
} from 'mdb-react-ui-kit';

function PreviewNavbar({ isHiden, logourl }) {
    const [openNav, setOpenNav] = useState(false);
    const [active, setActive] = useState("home")
    const [imageLoaded, setImageLoaded] = useState(true);

    useEffect(() => {

        const handleImageLoad = () => {
            setImageLoaded(true);
        };

        const handleImageError = () => {
            setImageLoaded(false);
        };

        const imgElement = document.createElement("img");
        imgElement.onload = handleImageLoad;
        imgElement.onerror = handleImageError;
        imgElement.src = logourl;

        return () => {
            imgElement.onload = null;
            imgElement.onerror = null;
        };
    }, [logourl]);
    return (
        <div>
            <MDBNavbar expand='lg' light bgColor='light' sticky style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                <MDBContainer fluid className='px-4'>
                    <MDBNavbarBrand href='#' className='brand-logo'>
                        <img src={imageLoaded ? logourl : BrandLogo} alt="Brand Logo"></img>
                    </MDBNavbarBrand>
                    <MDBNavbarToggler
                        type='button'
                        aria-expanded='false'
                        aria-label='Toggle navigation'
                        onClick={() => setOpenNav(!openNav)}
                    >
                        <MDBIcon icon='bars' fas />
                    </MDBNavbarToggler>
                    <MDBCollapse navbar open={openNav}>
                        <MDBNavbarNav>
                            <MDBNavbarItem className='navbar-list'>
                                <MDBNavbarLink
                                    active
                                    aria-current='page'
                                    href='#'
                                >
                                    Home
                                </MDBNavbarLink>
                            </MDBNavbarItem>
                            {!(isHiden.plans) && <MDBNavbarItem className='navbar-list'>
                                <MDBNavbarLink

                                    href='#'
                                >
                                    Plans
                                </MDBNavbarLink>
                            </MDBNavbarItem>}
                            {!(isHiden.contact) && <MDBNavbarItem className='navbar-list'>
                                <MDBNavbarLink
                                    href='#'
                                >
                                    Contact
                                </MDBNavbarLink>
                            </MDBNavbarItem>}
                            {/* <MDBNavbarItem className='navbar-list d-flex'>
                                <button className="btnn btn-1 hover-filled-slide-down">
                                    <span>Login</span>
                                </button>
                            </MDBNavbarItem> */}
                        </MDBNavbarNav>
                    </MDBCollapse>
                </MDBContainer>
            </MDBNavbar>
        </div>
    )
}

export default PreviewNavbar
